import { render, staticRenderFns } from "./change-personInfo.vue?vue&type=template&id=31bd16e8&scoped=true&"
import script from "./change-personInfo.vue?vue&type=script&lang=js&"
export * from "./change-personInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd16e8",
  null
  
)

export default component.exports